import { formatDateTime, formatRelativeTime } from '@/lib/utils';
import { cn } from '@/lib/utils';

const getEventTitle = (event) => {
  switch (event.event_type) {
    case 'submitted': return 'Service Request Submitted';
    case 'picked_up': return 'Request Picked Up for Review';
    case 'approved': return 'Service Request Approved';
    case 'rejected': return 'Service Request Rejected';
    case 'assigned': return 'Technician Assigned';
    case 'started': return 'Service Job Started';
    case 'completed': return 'Service Job Completed';
    case 'closed': return 'Ticket Closed';
    case 'note_added': return 'Update Added';
    default: return event.event_type.replace(/_/g, ' ');
  }
};

// Events that should never be shown to customers
const INTERNAL_NOTE_PREFIXES = [
  'Customer submitted staff reviews',
  'Ticket assigned to agent',
];

const isInternalNote = (event) => {
  if (event.event_type !== 'note_added') return false;
  if (!event.note) return false;
  return INTERNAL_NOTE_PREFIXES.some(prefix => event.note.startsWith(prefix));
};

export const Timeline = ({ events, className, customerView = false }) => {
  const visibleEvents = customerView
    ? (events || []).filter(e => !isInternalNote(e))
    : (events || []);

  if (!visibleEvents || visibleEvents.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No events yet
      </div>
    );
  }

  return (
    <div className={cn('space-y-3', className)} data-testid="timeline">
      {visibleEvents.map((event, index) => (
        <div key={event.id || index} className="flex gap-3">
          {/* Timeline line */}
          <div className="flex flex-col items-center">
            <div className="w-2.5 h-2.5 rounded-full bg-primary mt-1" />
            {index < visibleEvents.length - 1 && (
              <div className="w-0.5 h-full bg-border mt-1" />
            )}
          </div>
          
          {/* Event content */}
          <div className="flex-1 pb-4">
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <p className="font-bold text-slate-800 text-xs sm:text-sm capitalize">
                  {getEventTitle(event)}
                </p>
                {event.note && !customerView && (
                  <p className="text-xs text-slate-600 mt-1 bg-slate-50 p-2 rounded border border-slate-100 italic leading-relaxed">
                    {event.note}
                  </p>
                )}
                {event.from_status && event.to_status && event.from_status !== event.to_status && (
                  <p className="text-[10px] text-slate-400 mt-0.5">
                    Status: <span className="capitalize">{event.from_status.replace(/_/g, ' ')}</span> → <span className="capitalize">{event.to_status.replace(/_/g, ' ')}</span>
                  </p>
                )}

              </div>
              <div className="text-right shrink-0">
                <p className="text-[11px] font-bold text-slate-500">
                  {formatRelativeTime(event.created_at)}
                </p>
                <p className="text-[9px] text-slate-400">
                  {formatDateTime(event.created_at)}
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};